import { post } from 'api/request';
import urls from 'configs/urls';

export const uploadContent = (data, headers) =>
  post(headers, false, urls.files.contentUploader, data);
